<template>
  <div class="one-column-view">
    <div class="article-content">
      <h1 class="color-gold">
        {{
          showList
            ? $t("nft.all.title", { type: nftType.toUpperCase() })
            : nftID
        }}
      </h1>
      <div
        class="d-flex flex-column-reverse flex-md-row justify-content-center align-items-center justify-content-md-between"
      >
        <div class="nft-filters">
          <span
            :class="currentFilter == 'all' && 'active'"
            @click="filterNFT('all')"
          >
            {{ $t("nft.all.all") }}
          </span>
<!--          <span-->
<!--            :class="currentFilter == 'listed' && 'active'"-->
<!--            @click="filterNFT('listed')"-->
<!--          >-->
<!--            {{ $t("nft.all.listed") }}-->
<!--          </span>-->
<!--          <span-->
<!--            :class="currentFilter == 'auction' && 'active'"-->
<!--            @click="filterNFT('auction')"-->
<!--          >-->
<!--            {{ $t("nft.all.auction") }}-->
<!--          </span>-->
<!--          <span-->
<!--            :class="currentFilter == 'new' && 'active'"-->
<!--            @click="filterNFT('new')"-->
<!--          >-->
<!--            {{ $t("nft.all.new") }}-->
<!--          </span>-->
<!--          <span-->
<!--            :class="currentFilter == 'hasOffers' && 'active'"-->
<!--            @click="filterNFT('hasOffers')"-->
<!--          >-->
<!--            {{ $t("nft.all.hasOffers") }}-->
<!--          </span>-->
        </div>
        <div class="nft-search">
          <input
            type="text"
            :placeholder="$t('nft.all.search')"
            v-model="searchKeyword"
          />
          <div class="search-icon" @click="searchNFT">
            <svg
              width="22"
              height="22"
              viewBox="0 0 22 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.8473 20.1462L16.6351 14.9299C16.5382 14.833 16.4066 14.7786 16.2695 14.78H15.6991C17.1036 13.1575 17.8755 11.0825 17.8728 8.93666C17.8728 4.001 13.8713 0 8.93568 0C4.00002 0 -0.000976562 4.001 -0.000976562 8.93666C-0.000976562 13.8723 4.00002 17.8733 8.93568 17.8733C11.0815 17.8761 13.1565 17.1041 14.779 15.6996V16.2659C14.78 16.4025 14.8334 16.5337 14.929 16.6315L20.1452 21.8478C20.3463 22.0494 20.6727 22.0498 20.8742 21.8487C20.8747 21.8483 20.8747 21.8483 20.8751 21.8478L21.8459 20.877C22.0484 20.6769 22.0498 20.3501 21.8496 20.148C21.8491 20.1476 21.8482 20.1471 21.8473 20.1462ZM8.93568 15.8111C5.13899 15.8111 2.06122 12.7334 2.06122 8.93666C2.06122 5.13996 5.13899 2.0622 8.93568 2.0622C12.7324 2.0622 15.8101 5.13996 15.8101 8.93666C15.8101 12.7334 12.7324 15.8111 8.93568 15.8111Z"
                fill="#FFFFFF"
              />
            </svg>
          </div>
          <div
            class="clear-search btn btn-close"
            v-if="showSearch"
            @click="clearSearch"
          ></div>
        </div>
      </div>
      <div class="search-term" v-if="showSearch">
        {{ $t("nft.all.searchFor") }} {{ searchKeyword }}
      </div>
      <BPagination
        v-if="showList"
        v-model="currentPage"
        :total-rows="totalNFTs"
        :per-page="perPage"
        align="center"
        @change="getData"
      ></BPagination>
      <div class="nft-list" v-if="showList">
        <div
          class="nft-token-card p-2"
          v-for="(token, key) in nftTokens"
          :key="key"
          @click="showDetail(token.oid)"
        >
          <img
            :src="token.image"
            :alt="token.name"
            class="w-100"
          />
          <div class="card p-2 border-0">
            <div class="row">
              <div class="col-2 pe-0">
                <img
                  :src="
                    token.owner.avatar == 'default'
                      ? '../images/users/default-avatar.png'
                      : token.owner.avatar
                  "
                  alt="Avatar"
                  class="w-100"
                />
              </div>
              <div class="col-10">
                <div class="card-body p-0">
                  <h5 class="card-title m-0">{{ token.name }}</h5>
                  <p class="card-text">
                    <small>{{ token.owner.name }}</small>
                  </p>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="btn btn-sm btn-light">
                  {{ token.tradeInfo.eb }} {{ token.tradeInfo.cryptoType }}
                </div>
              </div>
              <div class="col-4">
                <div class="btn btn-sm btn-light">
                  {{ token.tradeInfo.wt }} {{ token.tradeInfo.cryptoType }}
                </div>
              </div>
              <div class="col-4 text-end">
                <div class="btn btn-sm btn-light">
                  {{ token.tradeInfo.og }} {{ token.tradeInfo.cryptoType }}
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-4 text-center">
                <small>{{ $t("nft.eb") }}</small>
              </div>
              <div class="col-4 text-center">
                <small>{{ $t("nft.wt") }}</small>
              </div>
              <div class="col-4 text-center">
                <small>{{ $t("nft.og") }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BPagination
        v-if="showList"
        v-model="currentPage"
        :total-rows="totalNFTs"
        :per-page="perPage"
        align="center"
        class="mt-5"
        @change="getData"
      ></BPagination>
      <div class="nft-detail" v-else>
        <NFTDetailsContent :nft="nft" @toggleIfr="toggleIfr" @goBack="goBack"></NFTDetailsContent>
      </div>
      <iframe v-show="ifrShow" ref="conn" src="http://nft.goldenlinkplus.net:3000/" allow="clipboard-write" style="width:100%;margin-left: auto; margin-right: auto; height: 100%; position:fixed; top: 0; left: 0"></iframe>
    </div>
  </div>
</template>

<script>
import NFTDetailsContent from "@/components/NFTDetailsContent.vue";
import { BPagination } from "bootstrap-vue";
import {getNftList, getNftSign} from "@/network/api";

export default {
  props: {
    nftType: String,
  },
  components: {
    NFTDetailsContent,
    BPagination,
  },
  data() {
    return {
      currentFilter: "all",
      nftTokens: [],
      searchKeyword: "",
      showSearch: false,
      showList: true,
      nftID: "",
      totalNFTs: 500,
      perPage: 24,
      currentPage: 1,

      //
      nft:{},

      ifrShow:false,
    };
  },
  mounted() {

    this.getData();
    this.iniShow();

    window.addEventListener('message', async (e) => {
      if (e.origin !== 'http://nft.goldenlinkplus.net:3000') {
        return;
      }
      if (e.data instanceof Object && e.data.type == "golden") {
        let mes = e.data
        if (mes.op == "close") {
          this.ifrShow = false;
        } else if (mes.op == "getAddress") {
          if (mes.code == 0) {
            //
            if(this.ifrShow){
              let info = await getNftSign({
                type: "1,2",
                address: mes.data,
                id: "100009"
              });
              this.$refs['conn'].contentWindow.postMessage({"op":"writeContract",data:info.data}, 'http://nft.goldenlinkplus.net:3000');
            }
            //
          }
        }
      }
    });
  },
  methods: {
    toggleIfr(){
      let ifr = this.$refs['conn'].contentWindow;
      ifr.postMessage({"op":"getAddress"}, 'http://nft.goldenlinkplus.net:3000');

      this.ifrShow = !this.ifrShow;
      if(this.ifrShow){
        //ifr.postMessage('Hello World', 'http://localhost:3000/');
      }
    },

    filterNFT(filter) {
      this.currentFilter = filter;
      this.showList = true;
      this.getData();
    },
    async getData(page) {
      // page
      if(page==undefined){
        page = 1;
      }
      // id
      let id = 0;
      if( this.searchKeyword ){
        id =  parseInt(this.searchKeyword) ;
        id = isNaN(id)?0:id;
      }
      //---
      window.scrollTo(0, 0);
      //const currentPath = this.$router.history.current.path.substring(1);
      //if (currentPath.includes("-showdetail-")) {
        //this.showList = false;
        //this.nftID = currentPath.split("-").pop();
      //}
      //---

      this.nftTokens = [];

      let res = null;
      let pre = "";
      let ossPre = "https://singapore1.oss-ap-southeast-1.aliyuncs.com/nfts/";
      let ossAf = "?x-oss-process=style/small";

      if(this.nftType=="gsg"){
        res = await getNftList({"type": 2, page,id});
        pre = "GSG";
      }else {
        res = await getNftList({"type": 1, page,id});
        pre = "GEMA";
      }

      this.totalNFTs = res.data.total;

      let list = res.data.list;
      //https://singapore1.oss-ap-southeast-1.aliyuncs.com/nfts/GEMA-00001.png
      for(let i = 0; i < list.length; i++){
        let nftId = (list[i].id+"").substr(1);
        const element = {
          oid : list[i].id,
          id: pre+nftId,
          name:pre+" Token #"+nftId,
          image:ossPre + pre +"-"+nftId+".png"+ossAf,
          category:pre,
          status:list[i].status,
          owner: {
            name: "Gold",
            avatar: "default",
          },
          tradeInfo: {
            cryptoType: "ETH",
            eb: "0.01",
            wt: "0.001",
            og: "0.00",
          },
        };
        this.nftTokens.push(element);
      }
    },
    iniShow() {
      if (this.$route.query.show) {
        switch (this.nftType) {
          case 'gsg':
            this.showDetail('GSG00117');
            break;
          case 'gema':
            this.showDetail('GEMA00418');
            break;
          default:
            break;
        }
      }
    },
    searchNFT() {
      this.showSearch = true;
      this.getData();
    },
    clearSearch() {
      this.showSearch = false;
      this.searchKeyword = "";
      this.getData();
    },
    showDetail(id) {
      this.nftID = "#"+(id+"").substr(1);
      this.showList = false;
      let tmp = this.nftTokens.filter(e=>id==e.oid);
      if(tmp.length>0){
        this.nft = tmp[0];
      }
    },
    goBack() {
      const currentPath = this.$router.history.current.path;
      console.log(currentPath)
      if (currentPath.includes("-showdetail-")) {
        const listUrl = currentPath.substring(0, currentPath.indexOf("-show"));
        this.$router.push(listUrl);
      } else {
        this.showList = true;
        this.nftID = "";
        this.getData();
      }
    },
  },
  watch: {
    $route() {
      this.showList = true;
      this.nftID = "";
      this.getData();
    },
  },
};
</script>

<style scoped>
.nft-filters {
  margin: 1rem 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.5rem;
  color: #3b3e51;
  font-weight: 600;
  overflow-x: auto;
  scrollbar-width: none;
  width: 100%;
  span {
    white-space: nowrap;
  }
  .active {
    background-color: #ef8200;
    color: white;
    font-size: 1.25rem;
    padding: 0.5rem 1.5rem;
    border-radius: 1.5rem;
  }
}
.nft-search {
  width: 100%;
  max-width: 346px;
  position: relative;
  input {
    background-color: #f8fffe;
    border: 1px solid #f5f5f5;
    height: 50px;
    width: calc(100% - 2rem);
    padding: 0 1.5rem;
  }
  .search-icon {
    height: 50px;
    position: absolute;
    top: 0;
    right: 0;
    background: linear-gradient(90deg, #06a5ff 0%, #3dde91 100%);
    padding: 9px 1rem;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    svg {
      width: 32px;
      height: 32px;
    }
  }
  .btn-close {
    right: 4.5rem;
    position: absolute;
    top: 0.8rem;
  }
}
.search-term {
  margin: 1rem 0;
}
.nft-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  align-items: center;
  gap: 1rem;
  .nft-token-card {
    background: white;
    box-shadow: 0px 0.15rem 1rem 0px #0007481f;
    border-radius: 1.3rem;
    overflow: hidden;
    width: 100%;
    max-width: 350px;
    img {
      margin: 0 auto 0.5rem;
    }
  }
}
.nft-detail {
  img {
    margin: 0;
    width: unset;
  }
}
</style>
